import { render } from "./input.vue?vue&type=template&id=d2b370f8&lang=pug"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"
script.render = render

export default script